module.exports = __webpack_public_path__ + "img/solution2.c12887d2.png";